/** Guard: испорченный счётчик (напр. из невалидированного deserialize) не должен молча рождать мусорные id. */
function assertSeq(seq, where) {
    if (!Number.isInteger(seq)) {
        throw new Error(`${where}: seq должен быть целым числом (получено ${seq})`);
    }
}
/** Каноничный id экземпляра по seq: "i{seq}" (tech/25 §2). Чистая функция. */
export function instanceIdOf(seq) {
    assertSeq(seq, 'instanceIdOf');
    return `i${seq}`;
}
/** Каноничный id эффекта по seq: "e{seq}". Чистая функция. */
export function effectIdOf(seq) {
    assertSeq(seq, 'effectIdOf');
    return `e${seq}`;
}
/**
 * Выдать следующий id экземпляра: продвигает счётчик nextInstanceSeq
 * В ПЕРЕДАННОМ ЧЕРНОВИКЕ и возвращает { id: "i{seq}", seq }.
 * Последовательные вызовы дают строго монотонные seq.
 */
export function nextInstanceId(draft) {
    const seq = draft.nextInstanceSeq;
    assertSeq(seq, 'nextInstanceId');
    draft.nextInstanceSeq = seq + 1;
    return { id: instanceIdOf(seq), seq };
}
/**
 * Выдать следующий id эффекта: продвигает счётчик nextEffectSeq
 * В ПЕРЕДАННОМ ЧЕРНОВИКЕ и возвращает { id: "e{seq}", seq }.
 */
export function nextEffectId(draft) {
    const seq = draft.nextEffectSeq;
    assertSeq(seq, 'nextEffectId');
    draft.nextEffectSeq = seq + 1;
    return { id: effectIdOf(seq), seq };
}
//# sourceMappingURL=ids.js.map